import { gql } from "apollo-boost"

export const CreateUser = gql`
mutation CreateUser($email: String!, $password: String!, $name: String!, $phone: String!){
  createUser(input: {
    email: $email,
    password: $password,
    name: $name,
    phone: $phone,
        }){
    email
    phone
    name
  }

  authUser(
      email: $email,
      password: $password
    ) {
      token
      user {
        id
        role
        name
        birthday
        phone
        type
        email
        document
        description
        photo
        phoneverif
        address {
          city
          state
          street
          zipcode
          number
          complement
          neighborhood
          country
        }
      }
    }
  }
`

export const SigninUser = gql`
mutation SigninUser($email: String!, $password: String!){
  authUser(
      email: $email,
      password: $password
    ) {
      token
      user {
        id
        role
        name
        birthday
        phone
        type
        email
        document
              description
        photo
        phoneverif
    
        address {
          city
          state
          street
          zipcode
          number
          complement
          neighborhood
          country
        }
      }
    }
  }
`

export const UserType = gql`
  {
    allUser(filter: {
    type: PROFISSIONAL
  }){
    photo
    id
    anuncios{
    skill{
        name
      }
    }
    name
    address {
      city
      state
    }
    ranks {
      media
    }
  }
  }
`

export const UserId = gql`
query($id: ID!){
  user(id: $id){
    id
    name
    birthday
    phone
    document
    type
    role
    photo
    email
    description
    phoneverif
    address {
      city
      state
      street
      zipcode
      number
      complement
      neighborhood
      country
    }
    ranks{
      media
      typeTo
      agilidade
      atendimento
      custo
      custoC
      ferramentas
      pontualidade
      pontualidadeC
      respeitoC
      resposta
      solucao
      transparenciaC
    }
    commentsTo{
      rating
      typeTo
      description
      rating
      createdAt
      reply
      propose {
        id
        anuncio {
          id
            skill {
              id
              name
            }
        }
      }
    }
    anuncios {
      id
      description
      skill {
        id
        name
      }
      price
      active
      files
    }
  }
}
`;

export const UserEmail = gql`
query($email: String!){
  allUsers(filter: {
    email: $email
  }){
    id
    email
    name
  }
}
`;

export const UserDoc = gql`
query($document: String!){
  allUsers(filter: {
    document: $document
  }){
    id
    email
    name
    document
  }
}
`;

export const UpdateUserDD = gql`
mutation UpdateUserDD(
    $document: String,
    $birthday: String
     ){
  updateUser(input: {
      document: $document
      birthday: $birthday
  }){
  id
  name
  birthday
  phone
  type
  role
  email
  description
  document
  photo
  phoneverif
  address {
    city
    state
    street
    zipcode
    number
    complement
    neighborhood
    country
  }                   
}
}
`

export const UpdateUser = gql`
mutation UpdateUser(
    $id: ID!,
    $zipcode: String!,
    $street: String,
    $number: String,
    $complement: String,
    $neighborhood: String,
    $city: String,
    $state: String,
    $country: String,
    $phone: String,
    $description: String,
    $email: String,
    $photo: String,
     ){
  updateUser(id: $id,
  input: {
      phone: $phone,
      description: $description,
      email: $email,
      photo: $photo,
    address: {
        zipcode: $zipcode,
        street: $street,
        number: $number,
        complement: $complement,
        neighborhood: $neighborhood,
        city: $city,
        state: $state,
        country: $country
  }
}){       
  id
  name
  birthday
  phone
  type
  role
  email
  photo
  description
  phoneverif
  document
  address {
    city
    state
    street
    zipcode
    number
    complement
    neighborhood
    country
  }
}
}
`

export const UpdatePhoto = gql`
mutation UpdateUser(
    $id: ID!,
    $photo: String
     ){
  updateUser(input: {
photo: $photo
  }){
  id
  name
  birthday
  phone
  role
  type
  email
  photo
  description
  phoneverif
  document
  address {
    city
    state
    street
    zipcode
    number
    complement
    neighborhood
    country
  }                                  
}
}
`

export const UpdateAddress = gql`
mutation UpdateAddress(
    $zipcode: String!,
    $street: String,
    $number: String,
    $complement: String,
    $neighborhood: String,
    $city: String,
    $state: String,
    $country: String,
     ){
  updateUser(
  input: {
    address: {
        zipcode: $zipcode,
        street: $street,
        number: $number,
        complement: $complement,
        neighborhood: $neighborhood,
        city: $city,
        state: $state,
        country: $country
        }
}){       
  id
  name
  birthday
  phone
  type
  email
  role
  photo
  description
  document
  phoneverif
  address {
    city
    state
    street
    zipcode
    number
    complement
    neighborhood
    country
  }
}
}
`

export const UpdateDescription = gql`
mutation UpdateUser(
    $id: ID!,
    $description: String,
     ){
  updateUser(id: $id,
  input: {
      description: $description
  }
){       
  id
  name
  birthday
  phone
  type
  email
  role
  photo
  description
  phoneverif
  document
  address {
    city
    state
    street
    zipcode
    number
    complement
    neighborhood
    country
  }
}
}
`

export const UpdatePhone = gql`
mutation UpdateUser(
    $id: ID!,
    $phone: String,
    $phoneverif: Boolean
     ){
  updateUser(id: $id,
  input: {
      phone: $phone,
      phoneverif: $phoneverif
  }
){       
  id
  name
  birthday
  phone
  type
  email
  role
  photo
  document
  description
  phoneverif
  address {
    city
    state
    street
    zipcode
    number
    complement
    neighborhood
    country
  }
}
}
`